/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.49
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SearchResult } from './SearchResult';
import {
    SearchResultFromJSON,
    SearchResultFromJSONTyped,
    SearchResultToJSON,
} from './SearchResult';

/**
 * 
 * @export
 * @interface SearchOverride
 */
export interface SearchOverride {
    /**
     * 
     * @type {Array<SearchResult>}
     * @memberof SearchOverride
     */
    documents: Array<SearchResult>;
    /**
     * 
     * @type {string}
     * @memberof SearchOverride
     */
    name: string;
}

/**
 * Check if a given object implements the SearchOverride interface.
 */
export function instanceOfSearchOverride(value: object): value is SearchOverride {
    if (!('documents' in value) || value['documents'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function SearchOverrideFromJSON(json: any): SearchOverride {
    return SearchOverrideFromJSONTyped(json, false);
}

export function SearchOverrideFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchOverride {
    if (json == null) {
        return json;
    }
    return {
        
        'documents': ((json['documents'] as Array<any>).map(SearchResultFromJSON)),
        'name': json['name'],
    };
}

export function SearchOverrideToJSON(value?: SearchOverride | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'documents': ((value['documents'] as Array<any>).map(SearchResultToJSON)),
        'name': value['name'],
    };
}

